import { useQuery } from "@tanstack/react-query";
import { getUserAccessMatrix } from "../api/rbac-api";
import type { UserAccessMatrix } from "../types/RolesPermissions.type";

export const USER_ACCESS_MATRIX_KEY = ["rbac", "user-access-matrix"] as const;

/**
 * PRO-731 — one user's roles x modules matrix.
 *
 * The SINGLE source for the "Roles & Permissions" modal from both entry points.
 * It previously ran on two different data paths — the admin one reading
 * System-Admin-only endpoints, the self one deriving rows from the effective
 * permissions payload — so the same user saw different rows and labels
 * depending on which screen opened it. There is deliberately no `mode` here:
 * the server gate admits the subject and the administrator alike, so there is
 * nothing left for the client to vary.
 */
export const useUserAccessMatrix = (userId: number | undefined, enabled = true) =>
	useQuery<UserAccessMatrix>({
		queryKey: [...USER_ACCESS_MATRIX_KEY, userId],
		queryFn: () => getUserAccessMatrix(userId as number),
		enabled: enabled && typeof userId === "number" && userId > 0,
		staleTime: 60 * 1000,
	});
